<template>
  <nav class="navbar navbar-dark px-2 bg-dark text-white navbar-expand-md bg-body-tertiary">
    <div class="d-flex flex-column w-100">
      <div class="d-flex align-items-center justify-content-between mb-2">
        <div class="d-flex w-100">
<!--          <svg class="me-2" width="1.5rem" height="1.5rem" fill="#fff">-->
<!--            <use xlink:href="../../assets/ico/bootstrap-icons.svg#r-square"/>-->
<!--          </svg>-->
          <div class="h-100 me-2" style="width: 1.5rem">
            <img class="img-fluid" src="../../assets/img/rm-logo_black-bg.svg" alt="RestMonster logotype">
          </div>
          <p class="m-0 fw-bold">
            {{ $t('nav.rm') }}
          </p>
        </div>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#companyNav" aria-controls="companyNav" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
      </div>
      <div class="collapse navbar-collapse flex-column" id="companyNav">
        <ul class="nav flex-column list-unstyled fw-normal pb-1 w-100">
          <li class="main-nav__item nav-item">
            <router-link to="/" class="nav-link d-inline-block px-2 py-1 mb-1 rounded">{{ $t('nav.home') }}</router-link>
          </li>
          <li class="main-nav__item nav-item">
            <router-link to="/restaurants" class="nav-link d-inline-block px-2 py-1 mb-1 rounded">{{ $t('nav.restaurants') }}</router-link>
          </li>
          <li class="main-nav__item nav-item">
            <router-link to="/statistics" class="nav-link d-inline-block px-2 py-1 mb-1 rounded">{{ $t('nav.statistics') }}</router-link>
          </li>
          <li class="main-nav__item nav-item">
            <router-link to="/settings" class="nav-link d-inline-block px-2 py-1 mb-1 rounded">{{ $t('nav.settings') }}</router-link>
          </li>
          <li class="main-nav__item nav-item">
            <router-link to="/users" class="nav-link d-inline-block px-2 py-1 mb-1 rounded text-muted">{{ $t('nav.users') }}</router-link>
          </li>
          <li class="main-nav__item nav-item">
            <router-link to="/couriers" class="nav-link d-inline-block px-2 py-1 mb-1 rounded text-muted">{{ $t('nav.couriers') }}</router-link>
          </li>
          <li class="main-nav__item nav-item">
            <router-link to="/integration" class="nav-link d-inline-block px-2 py-1 mb-1 rounded text-muted">{{ $t('nav.integration') }}</router-link>
          </li>
          <li class="main-nav__item nav-item">
            <router-link to="/reports" class="nav-link d-inline-block px-2 py-1 mb-1 rounded text-muted">{{ $t('nav.reports') }}</router-link>
          </li>
          <li class="main-nav__item nav-item">
            <router-link to="/rate" class="nav-link d-inline-block px-2 py-1 mb-1 rounded text-muted">{{ $t('nav.rate') }}</router-link>
          </li>
          <li class="main-nav__item nav-item">
            <router-link to="/delivery-zones" class="nav-link d-inline-block px-2 py-1 mb-1 rounded">{{ $t('nav.deliveryZones') }}</router-link>
          </li>
        </ul>
        <div class="d-flex w-100 mt-2 pt-2 border-top">
          <button
              @click="this.signOut"
              class="btn btn-outline-light border-0 p-1">
            <svg class="me-1" width="1.5rem" height="1.5rem" fill="currentColor">
              <use xlink:href="../../assets/ico/bootstrap-icons.svg#box-arrow-left"/>
            </svg> {{ $t('nav.signOut') }}
          </button>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "NavLeft",
  methods: {
    signOut() {
      this.$store.dispatch('signOut')
    }
  }

}
</script>

<style scoped>

</style>
